import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api";
import { Eye, EyeOff } from "lucide-react"; // Instale com: npm i lucide-react

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState("");
  const [cpf, setCpf] = useState("");
  const [name, setName] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const CODE_CORRETO = "123456";

  const handleRegister = async () => {
    if (!email || !password || !cpf || !name) {
      toast.warning("Preencha todos os campos.");
    } else {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        toast.error("Email inválido. Verifique e tente novamente.");
        return;
      }

      if (password.length < 6) {
        toast.error("A senha deve ter pelo menos 6 caracteres.");
        return;
      }

      // Verifica se a senha contém pelo menos um número e um caractere especial
      const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])/;

      if (!regex.test(password)) {
        toast.error(
          "A senha deve conter pelo menos um número e um caractere especial."
        );
        return;
      }

      if (password !== confirmPassword) {
        toast.error("As senhas não coincidem. Verifique e tente novamente.");
        return;
      }

      if (!/^\d{11}$/.test(cpf)) {
        toast.error("CPF inválido. Deve conter 11 dígitos.");
        return;
      }

      if (code !== CODE_CORRETO) {
        toast.error("Código incorreto. Verifique e tente novamente.");
        return;
      }

      try {
        await api.post("/user/register", { email, password, cpf, name });
        toast.success("Cadastro realizado com sucesso! Faça login.");
        navigate("/login");
      } catch (err) {
        console.error(err);
        toast.error(
          err.response?.data?.error || "Erro ao cadastrar. Tente novamente."
        );
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-image" />
      <div className="auth-card-container">
        <div className="auth-card">
          <h2>Cadastro</h2>
          <input
            className="input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="input-password-container">
            <input
              className="input"
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          <div className="input-password-container">
            <input
              className="input"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirmar Senha"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span
              className="eye-icon"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          <input
            className="input"
            placeholder="Nome Completo"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            className="input"
            placeholder="CPF"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
          />
          <input
            className="input"
            placeholder="Código (6 dígitos)"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength={6}
          />
          <button className="button button-azul" onClick={handleRegister}>
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  );
}
